import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import InnerJourney from "@/pages/InnerJourney";
import Feeling from "@/pages/Feeling";
import Space from "@/pages/Space";
import About from "@/pages/About";
import Mission from "@/pages/Mission";
import Consultation from "@/pages/Consultation";
import ExperienceProgram from "@/pages/ExperienceProgram";
import ExperiencePrograms from "@/pages/ExperiencePrograms";
import CurrentPrograms from "@/pages/CurrentPrograms";
import NewsletterConfirmed from "@/pages/NewsletterConfirmed";
import ExperienceRegistration from "@/pages/ExperienceRegistration";
import ExperienceThankYou from "@/pages/ExperienceThankYou";
import Testimonials from "@/pages/Testimonials";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import ForrasKodKiseres from "@/pages/ForrasKodKiseres";
import Szolgaltatasok from "@/pages/Szolgaltatasok";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";
import ScrollToTop from "@/components/ScrollToTop";
import { AdminAuthProvider, RequireAdmin } from "@/admin/AdminAuth";
import AdminLayout from "@/admin/AdminLayout";
import AdminLogin from "@/admin/pages/AdminLogin";
import AdminDashboard from "@/admin/pages/AdminDashboard";
import AdminPrograms from "@/admin/pages/AdminPrograms";
import AdminProgramEdit from "@/admin/pages/AdminProgramEdit";
import AdminRegistrations from "@/admin/pages/AdminRegistrations";
import AdminSettings from "@/admin/pages/AdminSettings";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App bg-warm">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/kapcsolodas-melysegei" element={<InnerJourney />} />
          <Route path="/egy-erzes" element={<Feeling />} />
          <Route path="/milyen-terbe-erkezel" element={<Space />} />
          <Route path="/ki-vagyok-en" element={<About />} />
          <Route path="/misszio" element={<Mission />} />
          <Route path="/elmenyprogramok" element={<ExperiencePrograms />} />
          <Route path="/aktualis-programok" element={<CurrentPrograms />} />
          <Route path="/feliratkozas-megerositve" element={<NewsletterConfirmed />} />
          <Route path="/elmenyprogram" element={<ExperienceProgram />} />
          <Route path="/elmenyprogram/jelentkezes" element={<ExperienceRegistration />} />
          <Route path="/elmenyprogram/koszonet" element={<ExperienceThankYou />} />
          <Route path="/visszajelzesek" element={<Testimonials />} />
          <Route path="/adatkezelesi-tajekoztato" element={<PrivacyPolicy />} />
          <Route path="/konzultacio" element={<Consultation />} />
          <Route path="/forras-kod-kiseres" element={<ForrasKodKiseres />} />
          <Route path="/szolgaltatasok" element={<Szolgaltatasok />} />
          <Route path="/kapcsolat" element={<Contact />} />
          <Route path="/admin/belepes" element={<AdminAuthProvider><AdminLogin /></AdminAuthProvider>} />
          <Route path="/admin" element={<AdminAuthProvider><RequireAdmin><AdminLayout /></RequireAdmin></AdminAuthProvider>}>
            <Route index element={<AdminDashboard />} />
            <Route path="programok" element={<AdminPrograms />} />
            <Route path="programok/:id" element={<AdminProgramEdit />} />
            <Route path="jelentkezok" element={<AdminRegistrations />} />
            <Route path="beallitasok" element={<AdminSettings />} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#FFFFFF",
            color: "#2A2A2A",
            border: "1px solid #E6E1D8",
            fontFamily: "Inter, sans-serif",
            borderRadius: "2px",
          },
        }}
      />
    </div>
  );
}

export default App;
